export const moreIcon = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="9.99903" cy="10" r="2.00098" fill="#191919"/>
<circle cx="3.00195" cy="10" r="2.00097" fill="#191919"/>
<circle cx="17.0019" cy="10" r="2.00097" fill="#191919"/>
</svg>
`;
